<template>
  <el-popover v-if="item && url" :visible="true" virtual-triggering :virtual-ref="anchor"
    placement="right" :width="300" :fallback-placements="['left', 'top', 'bottom']"
    :popper-options="{ modifiers: [{ name: 'preventOverflow', options: { padding: 12, altAxis: true, tether: false } }] }"
    :persistent="false" popper-class="video-library-preview">
    <div :key="url" class="library-preview-content" @mouseenter="emit('keep')" @mouseleave="emit('leave')">
      <div v-if="failed" class="library-preview-error">暂时无法预览此素材</div>
      <video v-else-if="type === 'video'" :src="url" controls autoplay muted playsinline @error="failed = true" />
      <audio v-else-if="type === 'audio'" :src="url" controls preload="metadata" @error="failed = true" />
      <button v-else type="button" class="library-hover-enlarge" :aria-label="`放大查看 ${name}`" @click="emit('preview', item)">
        <img :src="url" :alt="name" @error="failed = true" /><span>点击放大查看</span>
      </button>
      <span>{{ name }}</span>
    </div>
  </el-popover>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed, ref, watch } from 'vue'
import { assetDisplayName, assetMediaType } from '../model/assetLibrarySelection'
const props = defineProps({ item: { type: Object, default: null }, anchor: { type: Object, default: null } })
const emit = defineEmits(['keep', 'leave', 'preview'])
const name = computed(() => props.item ? assetDisplayName(props.item) : '')
const type = computed(() => props.item ? assetMediaType(props.item) : '')
const url = computed(() => props.item ? [props.item.mediaUrl, props.item.sourceUrl, props.item.coverUrl, props.item.localUrl, props.item.url]
  .find(value => value && !String(value).startsWith('asset://')) || '' : '')
const failed = ref(false)
watch(url, () => { failed.value = false })
</script>

<style scoped>
.library-preview-content { display: flex; flex-direction: column; gap: 10px; }
.library-preview-content img, .library-preview-content video { display: block; width: 100%; max-height: 320px; object-fit: contain; border-radius: 6px; background: #141414; }
.library-preview-content audio { width: 100%; }
.library-preview-content > span { overflow-wrap: anywhere; font-size: 12px; color: #ddd; }
.library-preview-error { padding: 28px 12px; color: #aaa; text-align: center; }
.library-hover-enlarge { position: relative; padding: 0; border: 0; background: transparent; cursor: zoom-in; }
.library-hover-enlarge span { position: absolute; bottom: 8px; left: 50%; transform: translateX(-50%); padding: 4px 8px; border-radius: 5px; background: #222d; color: #eee; white-space: nowrap; font-size: 11px; }
:global(.video-library-preview.el-popper) { max-width: calc(100vw - 24px); box-sizing: border-box; background: #292929; border-color: #555; color: #ddd; color-scheme: dark; }
:global(.video-library-preview .el-popper__arrow::before) { background: #292929; border-color: #555; }
</style>
